
import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { NgbDateStruct, NgbCalendar } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-date-time-picker',
  templateUrl: './date-time-picker.component.html',
  styleUrls: ['./date-time-picker.component.scss']
})
export class DateTimePickerComponent implements OnInit {

  @Output() onSet: EventEmitter<string> = new EventEmitter();

  dateModel: NgbDateStruct

  time = {
    hour: 12,
    minute: 0,
    second: 0,
  };

  constructor(private calendar: NgbCalendar) {
    this.dateModel = this.calendar.getToday();
  }

  ngOnInit() {

  }

  protected getDateTime() {
    var date;
    var time;

    date = this.format(this.dateModel.year) + "-" + this.format(this.dateModel.month) + "-" + (this.dateModel.day);
    time = this.format(this.time.hour) + ":" + this.format(this.time.minute) + ":" + "00";

    this.onSet.emit(date + " " + time);
  }

  private format(number: number) {
    if (number < 10) {
      return "0" + number;
    }
    return number;
  }
}
